import React from 'react';
import style from './style';

const HistoramFake = () => {
  return (
    <>
      <div className="histogram-sketelon fadeOutBuyCardSkeleton">
          <div className="histogram-sketelon--container">
            <div className="skeleton histogram-sketelon--container--bar--small" />
            <div className="skeleton histogram-sketelon--container--bar--medium" />
            <div className="skeleton histogram-sketelon--container--bar--medium" />
            <div className="skeleton histogram-sketelon--container--bar--medium" />
            <div className="skeleton histogram-sketelon--container--bar--small" />
            <div className="skeleton histogram-sketelon--container--bar--small" />
          </div>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default HistoramFake;